<a
    class="block w-full h-full"
    [href]="translatedUrl()"
    [attr.aria-label]="ariaLabel() | translate"
    (click)="linkClicked($event)"
>
    <ng-content></ng-content>
</a>
